<template>
  <div class="index-page container">
    <n-card :loading="$var('loadImage')" style="max-width: 1000px;">
      <h3 slot="header">Изображение</h3>
      <n-image inline centered bg :src="image" />
    
      <n-form @submit="saveImage">
        <n-items>
          <n-upload title="Загрузить новое изображение" :value.sync="newImage" />
          <br />
          <n-button color="primary" type="submit">Загрузить</n-button>
        </n-items>
      </n-form>
    </n-card>
    
    <n-card :loading="$var('load')" style="max-width: 1000px;">
      <h3 slot="header">Информация</h3>
      <n-form @submit="submit">
        <n-items style="margin-bottom: 10px;">
          <n-input title="Имя" v-bind="$form.input('name')" />
          <n-input title="Должность" v-bind="$form.input('position')" />
          <n-input title="Ссылка" v-bind="$form.input('url')" />
          <n-textarea title="Описание" v-bind="$form.input('content')" />
          <n-button color="primary" type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
  
    <n-card :loading="$var('loadDelete')" style="max-width: 1000px;">
      <h3 slot="header">Удаление отзыва</h3>
      Осторожно! Удаление действие необратимо!
      <br />
      <n-button color="danger" style="margin-top: 10px; font-size: .7em" @click="deleteModel">Удалить отзыв</n-button>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    image: null,
    newImage: null,
  }),
  computed: {
    modelId() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.loadModel()
  },
  methods: {
    loadModel() {
      this.$var('load', true)
      $api.app.students.get(this.modelId).then((response) => {
        const result = response.data.content
        this.image = result.avatar
        this.$form.init(result)
        this.$form.set('avatar', undefined)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      $api.app.students.edit(this.modelId, this.$form.get()).then((result) => {
        this.loadModel()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    saveImage() {
      this.$var('loadImage', true)
      $api.files.create({ file: this.newImage, }).then((file) => {
        $api.app.students.edit(this.modelId, { avatar: file.data.content.id, }).then((result) => {
          this.image = result.data.content.avatar
          this.newImage = null
        }).finally(() => {
          this.$var('loadImage', false)
        })
      }).catch(() => {
        this.$var('loadImage', false)
      })
    },
    deleteModel() {
      this.$var('loadDelete', true)
      $api.app.students.delete(this.modelId).then((response) => {
        this.$router.push({ name: 'students.list', })
      }).finally(() => {
        this.$var('loadDelete', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 180px;
    --n-image-height: 200px;
    
    .avatar {
      border: 2px solid red;
    }
  }
</style>
